﻿const PLACEHOLDER = 'container_err';

function processError(xhr, settings, callback) {
	var text = '';
	var title = localization.resources.title.systemError;
	var showinframe = false;
	var severity = 'err';

	if (xhr.status == '401') {
		const location = xhr.getResponseHeader('location');
		if (location) {
			window.location = location;
			callback(xhr, settings);
			return;
		}
		else {
			title = localization.resources.title.noAccess;
			text = localization.resources.text.notLoggedSystem;
			severity = 'warn';
		}
	}
	else if (xhr.status == '403') {
		title = localization.resources.title.noAccess;
		text = localization.resources.text.insufficientPermissionsOperation;
		severity = 'warn';
	}
	else if (xhr.status == '404') {
		title = localization.resources.title.pageMissing;
		text = localization.resources.text.linkGoToMainPage;
		severity = 'warn';
	}
	else if (xhr.status == 0) {
		title = localization.resources.title.ajaxError;
		text = 'Сервер недоступен или не отвечает.<br><br>Адрес: ' + settings.url;
	}
	else {
		text = xhr.responseText;
		showinframe = true;
	}

	callback(xhr, settings);
	showError(title, text, severity, showinframe);
}

function showError(title, text, severity, showinframe) {
    if (!window.dialog) {
        document.body.innerHTML = title + '<br/><pre>' + text + '</pre>';
        return;
    }

    const errd = document.getElementById(PLACEHOLDER);
    const errt = document.getElementById(PLACEHOLDER + '_title');
    const errb = document.getElementById(PLACEHOLDER + '_body');

    errt.innerHTML = title;

    errd.classList.remove('err', 'warn', 'info');
    errd.classList.add(severity);

    let frame = document.getElementById(PLACEHOLDER + '_frame');

    if (showinframe) {
        if (!frame) {
            frame = document.createElement('iframe');
            frame.id = PLACEHOLDER + '_frame';
            errt.insertAdjacentElement('afterEnd', frame);
        }
        frame.classList.remove('hide');
        errb.classList.add('hide');
        frame.contentWindow.contents = text;
        frame.src = 'javascript:window["contents"]';
    } else {
        if (frame) frame.classList.add('hide');
        errb.classList.remove('hide');
        errb.innerHTML = '<pre>' + text + '</pre>';
    }

    dialog.open(PLACEHOLDER);
}

module.exports = { showError, processError };